import { ContextFilters } from '../../../types/context/ContextFilters'

const personnelQueryKeys = {
  all: [{ scope: 'personnel' }] as const,
  lists: () => [{ ...personnelQueryKeys.all[0], entity: 'list' }] as const,
  list: (context: Pick<ContextFilters, 'companyId'>) => [{ ...personnelQueryKeys.lists()[0], ...context }] as const
}

export default personnelQueryKeys
